import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../firebase';

const functions = getFunctions(app, 'europe-west1');

interface CheckoutSessionResult {
  url: string;
}

interface PortalSessionResult {
  url: string;
}

export const createCheckoutSession =
  async (): Promise<CheckoutSessionResult> => {
    const fn = httpsCallable<void, CheckoutSessionResult>(
      functions,
      'createCheckoutSession'
    );
    const result = await fn();
    return result.data;
  };

export const createCustomerPortalSession =
  async (): Promise<PortalSessionResult> => {
    const fn = httpsCallable<void, PortalSessionResult>(
      functions,
      'createCustomerPortalSession'
    );
    const result = await fn();
    return result.data;
  };

export const startTrial = async (): Promise<{ success: boolean }> => {
  const fn = httpsCallable<void, { success: boolean }>(functions, 'startTrial');
  const result = await fn();
  return result.data;
};

export const deleteAccount = async (): Promise<{ success: boolean }> => {
  const fn = httpsCallable<void, { success: boolean }>(
    functions,
    'deleteAccount'
  );
  const result = await fn();
  return result.data;
};
